import { render, staticRenderFns } from "./CapitalAllocation.vue?vue&type=template&id=bf93efca&scoped=true"
import script from "./CapitalAllocation.vue?vue&type=script&lang=js"
export * from "./CapitalAllocation.vue?vue&type=script&lang=js"
import style0 from "./CapitalAllocation.vue?vue&type=style&index=0&id=bf93efca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf93efca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf93efca')) {
      api.createRecord('bf93efca', component.options)
    } else {
      api.reload('bf93efca', component.options)
    }
    module.hot.accept("./CapitalAllocation.vue?vue&type=template&id=bf93efca&scoped=true", function () {
      api.rerender('bf93efca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/conventional/dialogs/CapitalAllocation.vue"
export default component.exports